var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowHigherThan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.949613 0.449533C1.43777 -0.0386238 2.22922 -0.0386238 2.71738 0.449533L9.38405 7.1162C9.8722 7.60435 9.8722 8.39581 9.38405 8.88397L2.71738 15.5506C2.22922 16.0388 1.43777 16.0388 0.949613 15.5506C0.461458 15.0625 0.461458 14.271 0.949613 13.7829L6.7324 8.00008L0.949613 2.2173C0.461457 1.72914 0.461457 0.937686 0.949613 0.449533Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHigherThan);
export default __webpack_public_path__ + "static/media/ArrowHigherThan.24aa05b5dd0a356d4e70d96f4506e771.svg";
export { ForwardRef as ReactComponent };